module.exports = __webpack_public_path__ + "img/login-hero-mobile-2.50640d4e.jpg";